import { SubjectsTypes } from 'shared/constants/subjects.types';

export const subjects: SubjectsTypes = [
  {
    id: '108',
    name: 'Математика',
    imageName: 'matematika',
    link: 'matematika',
  },
  {
    id: '114',
    name: 'Русский язык',
    imageName: 'russkiy-yazyk',
    link: 'russkiy-yazyk',
  },
  {
    id: '127',
    name: 'Геометрия',
    imageName: 'geometriya',
    link: 'geometriya',
  },
  {
    id: '110',
    name: 'Литература',
    imageName: 'literatura',
    link: 'literatura',
  },
  {
    id: '107',
    name: 'Английский язык',
    imageName: 'angliyskiy-yazyk',
    link: 'angliyskiy-yazyk',
  },
  {
    id: '105',
    name: 'История',
    imageName: 'istoriya',
    link: 'istoriya',
  },
  {
    id: '111',
    name: 'География',
    imageName: 'geografiya',
    link: 'geografiya',
  },
  {
    id: '109',
    name: 'Биология',
    imageName: 'biologiya',
    link: 'biologiya',
  },
  {
    id: '104',
    name: 'Окружающий мир',
    imageName: 'okruzhayuschiy-mir',
    link: 'okruzhayuschiy-mir',
  },
  {
    id: '112',
    name: 'Физика',
    imageName: 'fizika',
    link: 'fizika',
  },
  {
    id: '113',
    name: 'Информатика',
    imageName: 'informatika',
    link: 'informatika',
  },
  {
    id: '116',
    name: 'Литератур-ное чтение',
    imageName: 'literaturnoe-chtenie',
    link: 'literaturnoe-chtenie',
  },
  {
    id: '132',
    name: 'Химия',
    imageName: 'himiya',
    link: 'himiya',
  },
  {
    id: '115',
    name: 'Общество-знание',
    imageName: 'obschestvoznanie',
    link: 'obschestvoznanie',
  },
  {
    id: '119',
    name: 'Музыка',
    imageName: 'muzyka',
    link: 'muzyka',
  },
  {
    id: '125',
    name: 'Астрономия',
    imageName: 'astronomiya',
    link: 'astronomiya',
  },
  {
    id: '129',
    name: 'Экономика',
    imageName: 'ekonomika',
    link: 'ekonomika',
  },
  {
    id: '120',
    name: 'Родной край',
    imageName: 'rodnoy-kray',
    link: 'rodnoy-kray',
  },
  {
    id: '121',
    name: 'Истоки',
    imageName: 'istoki',
    link: 'istoki',
  },
  {
    id: '118',
    name: 'Естество-знание',
    imageName: 'estestvoznanie',
    link: 'estestvoznanie',
  },
  {
    id: '117',
    name: 'ОБЖ',
    imageName: 'obzh',
    link: 'obzh',
  },
  {
    id: '122',
    name: 'Технология',
    imageName: 'tehnologiya',
    link: 'tehnologiya',
  },
  {
    id: '131',
    name: 'Французский язык',
    imageName: 'frantsuzskiy-yazik',
    link: 'frantsuzskiy-yazik',
  },
  {
    id: '124',
    name: 'Краеведение',
    imageName: 'kraevedenie',
    link: 'kraevedenie',
  },
  {
    id: '123',
    name: 'Кубано-ведение',
    imageName: 'kubanovedenie',
    link: 'kubanovedenie',
  },
  {
    id: '128',
    name: 'Черчение',
    imageName: 'cherchenie',
    link: 'cherchenie',
  },
  {
    id: '126',
    name: 'Немецкий язык',
    imageName: 'nemetskiy-yazik',
    link: 'nemetskiy-yazik',
  },
  {
    id: '130',
    name: 'Право',
    imageName: 'pravo',
    link: 'pravo',
  },
  {
    id: '106',
    name: 'Природо-ведение',
    imageName: 'prirodovedenie',
    link: 'prirodovedenie',
  },
];
